import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { roundUpToNearestRange } from '../methods/contentFormatHelpers';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  ChartDataLabels
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top' as const,
    },
    title: {
      display: true,
      text: 'Kształtowanie się przepływów pienięznych netto oraz NPV',
    }
  }
};

const labels = [...Array(10)].map((_, index) => {
  return 'n+' + index
})

interface AreaChartProps {
    przeplywy_pieniezne_netto: number[],
    npv: []
}
// @ts-ignore
const AreaChart = ( props: AreaChartProps ) => {
  return (
    <Line
      options={{...options, scales: {
        y: {
          max: roundUpToNearestRange( Math.max(...props.przeplywy_pieniezne_netto.slice(0, 10))  +Math.max(...props.npv.slice(0, 10)) ),
          min: roundUpToNearestRange( (Math.min(...props.przeplywy_pieniezne_netto.slice(0, 10))  +Math.min(...props.npv.slice(0, 10)))*-1 )*-1
        }
      }, layout: {
        padding: {
          top: 50,
          right: 50,
        }
      }
      }}
      data={{
        labels,
        datasets: [
          {
            fill: true,
            label: 'NPV',
            data: props.npv.slice(0, 10).map(elem => Math.round(elem*100)/100),
            borderColor: 'rgba(251, 186, 0, 1)',
            backgroundColor: 'rgba(251, 186, 0, 0.5)',
            stack: 'stack1', // Set the same stack name for the second dataset
            datalabels: {
              display: false
            }
          },
          {
            fill: true,
            label: 'Przepływy pieniężne netto', // Corrected label to avoid duplicate labels
            data: props.przeplywy_pieniezne_netto.slice(0, 10).map(elem => Math.round(elem*100)/100),
            borderColor: 'rgba(24, 53, 87, 1)',
            backgroundColor: 'rgba(24, 53, 87, 0.5)',
            stack: 'stack1', // Set a unique stack name for the first dataset
            datalabels: {
              display: false
            }
          }
        ],
      }}
    />
  );
};

export default AreaChart;